import type { ReactNode } from 'react';
import styles from './ui.module.css';

/**
 * Разделы ОДНОЙ карточкой, разделённые волосяной линией.
 *
 * Так набран кабинет в макетах: склад, питомцы и способности — это не три
 * независимые сущности, а три полки одного шкафа, и раздельные карточки
 * читались как три разных предложения. Там, где разделы и правда разные
 * (вкладка «Ещё»), карточки остаются отдельными — это CardList.
 */
export function NavList({ children }: { children: ReactNode }) {
  return (
    <div className={styles.navListOuter}>
      <div className={styles.navList}>{children}</div>
    </div>
  );
}
